/**
 * Is a case waiting on someone else, and on whom (waiting filter round)?
 *
 * Since proposal 5 the server says it: a case with an open ask is in their
 * court (DoorInvestigationRead.court, derived from the asks under one rule).
 * The names are everyone with an open ask on the case, oldest first; when
 * the asks visible here name nobody, the court's own person stands in.
 *
 * Pure logic (repo convention: logic in .ts, components in .tsx).
 */
import type { DoorInvestigationRead } from '../../services/qcpInvestigations';
import type { DoorDataRequestRead } from '../../services/qcpDataRequests';
import { isActiveCase } from '../../components/portal/investigationsView';
import { waitingOnNames } from './qualityWorkspaceView';

/** Who an open case waits on (names, oldest ask first), or null when it is
 *  not in their court. */
export function caseWaitsOn(
  inv: DoorInvestigationRead,
  asks: DoorDataRequestRead[],
): string[] | null {
  if (!isActiveCase(inv) || inv.court.side !== 'theirs') return null;
  const names = waitingOnNames(asks);
  if (names.length > 0) return names;
  return inv.court.person ? [inv.court.person] : [];
}

/** How long it has waited (oldest open ask first); cases with no ask last. */
export function waitingSince(inv: Pick<DoorInvestigationRead, 'oldest_open_request_at'>): number {
  const t = inv.oldest_open_request_at ? new Date(inv.oldest_open_request_at).getTime() : NaN;
  return Number.isNaN(t) ? Number.POSITIVE_INFINITY : t;
}
